import React from "react";
import BurgerMenu from "./layouts/burger";
import IconsMenu from "./layouts/icons";
import DefaultMenu from "./layouts/default";
import CPMenu from "./layouts/cp";

const MENU_LAYOUTS = {
  BURGER: "burguer",
  ICONS: "icons",
  DEFAULT: "default",
  CP: "cp",
};

const Menu = (props) => {
  const { layout } = props;
  switch (layout) {
    case MENU_LAYOUTS.CP:
      return <CPMenu {...props} />;
    case MENU_LAYOUTS.BURGER:
      return <BurgerMenu {...props} />;
    case MENU_LAYOUTS.DEFAULT:
      return <DefaultMenu {...props} />;
    case MENU_LAYOUTS.ICONS:
      return <IconsMenu {...props} />;
    default:
      return null;
  }
};
export default Menu;
